export default [
    {
        component: () => import(/* webpackChunkName: 'painel-senha-fila-atendimento' */ '@/views/painel-senha/fila-atendimento/Index'),
        path: 'fila-atendimento',
        redirect: 'fila-atendimento/index',
        children: [
            {
                component: () => import(/* webpackChunkName: 'painel-senha-fila-atendimento' */'@/views/painel-senha/fila-atendimento/List.vue'),
                name: 'painel-senha-fila-atendimento-index',
                path: 'index',
            },
        ],
    },
]